export default __webpack_public_path__ + "static/media/kitchen5-beforeC-2048w.85261d8b.webp";